import { CssBaseline, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { svSE } from '@mui/x-date-pickers/locales';
import { AlertProvider } from '../../contexts/AlertContext';
import { ModalProvider } from '../../contexts/ModalContext';
import { theme } from '../../configs/theme';

type RootProvidersProps = {
  children: React.ReactNode;
};

export const RootLayout = ({ children }: RootProvidersProps) => {
  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="sv"
      localeText={svSE.components.MuiLocalizationProvider.defaultProps.localeText}
    >
      {/* Outside the providers that render UI of their own, such as the alert, so it uses the app's theme. */}
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AlertProvider>
          <ModalProvider>{children}</ModalProvider>
        </AlertProvider>
      </ThemeProvider>
    </LocalizationProvider>
  );
};
